import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { Warning } from "@mui/icons-material";
import { useModals } from "../../store/dialogs/hooks.js";

export const UntaggedRegionsDialog = ({
  cutRegion,
  selectedTag,
  untaggedAnnotationMessage,
}) => {
  const { showUntaggedRegionsDialog, closeUntaggedRegionsDialog } = useModals();
  return (
    <Dialog
      aria-labelledby="untagged-dialog"
      aria-describedby="untagged-dialog-description"
      aria-hidden={!showUntaggedRegionsDialog}
      closeAfterTransition={false}
      onClose={() => closeUntaggedRegionsDialog()}
      open={showUntaggedRegionsDialog}
      maxWidth="xs"
      slots={{
        transition: Transition,
      }}
      keepMounted
    >
      <DialogTitle
        id="untagged-dialog-title"
        display="flex"
        alignItems="center"
        gap={0.5}
      >
        <Warning color="warning" fontSize="medium" />
        Warning
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="untagged-dialog-description">
          {untaggedAnnotationMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => closeUntaggedRegionsDialog()}>
          cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            closeUntaggedRegionsDialog();
            cutRegion(selectedTag);
          }}
          autoFocus
        >
          continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
